import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
    const { t } = useTranslation();

    return (
        <div className="max-w-4xl mx-auto space-y-8">
            {/* Hero Section */}
            <div className="text-center space-y-4">
                <h1 className="text-4xl font-bold text-gray-900">
                    <span className="bg-gradient-to-r from-green-600 to-green-800 bg-clip-text text-transparent">
                        {t('about.title', 'About MuslimTree')}
                    </span>
                </h1>
                <p className="text-lg text-gray-600">
                    {t('about.subtitle', 'Your Gateway to Islamic Knowledge')}
                </p>
            </div>

            {/* Mission Section */}
            <div className="bg-white rounded-lg shadow-sm p-8 border border-gray-100">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                    {t('about.mission.title', 'Our Mission')}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                    {t('about.mission.description', 'MuslimTree aims to provide a comprehensive and interactive platform for exploring Islamic knowledge. We strive to make Islamic history, teachings, and wisdom accessible to everyone through modern technology and user-friendly interfaces.')}
                </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow duration-200">
                    <div className="text-green-600 mb-4">
                        <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {t('about.features.authentic.title', 'Authentic Sources')}
                    </h3>
                    <p className="text-gray-600">
                        {t('about.features.authentic.description', 'We carefully curate content from verified and authentic Islamic sources to ensure accuracy and reliability.')}
                    </p>
                </div>

                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow duration-200">
                    <div className="text-green-600 mb-4">
                        <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {t('about.features.interactive.title', 'Interactive Learning')}
                    </h3>
                    <p className="text-gray-600">
                        {t('about.features.interactive.description', 'Our platform offers interactive visualizations and dynamic content to make learning engaging and effective.')}
                    </p>
                </div>

                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow duration-200">
                    <div className="text-green-600 mb-4">
                        <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {t('about.features.multilingual.title', 'Multilingual Support')}
                    </h3>
                    <p className="text-gray-600">
                        {t('about.features.multilingual.description', 'Access content in multiple languages, making Islamic knowledge accessible to a global audience.')}
                    </p>
                </div>

                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow duration-200">
                    <div className="text-green-600 mb-4">
                        <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {t('about.features.comprehensive.title', 'Comprehensive Content')}
                    </h3>
                    <p className="text-gray-600">
                        {t('about.features.comprehensive.description', 'Explore a wide range of topics including Quran, Hadith, Islamic history, and scholarly works.')}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About; 